import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedSettingsRoute extends BaseRoute {}
